import React from 'react';
import ReactDOM from 'react-dom';
import App from './pages/app';
import store from './store';
import { Provider } from 'react-redux';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import * as moment from 'moment';
import 'moment/locale/pt-br.js';
import { LicenseInfo } from '@mui/x-license-pro';

moment.locale('pt-br');
LicenseInfo.setLicenseKey(
  'de6f2deb89c66ee5e398cd4bff74136aTz02MjY3MCxFPTE3MTEyMjY0NzUyMjAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI='
);

ReactDOM.render(
  <React.StrictMode>
    <MuiPickersUtilsProvider utils={MomentUtils} libInstance={moment} locale="pt-BR">
      <Provider store={store}>
        <App />
      </Provider>
    </MuiPickersUtilsProvider>
  </React.StrictMode>,
  document.getElementById('root')
);



